export default () => ({
  paper: { width: '400px' },
  content: {
    color: 'rgba(0, 0, 0, 0.60)',
  },
  dadosContratoStyle: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});
